import { render, staticRenderFns } from "./OrdersItemsList.vue?vue&type=template&id=6a1eea48&"
import script from "./OrdersItemsList.vue?vue&type=script&lang=js&"
export * from "./OrdersItemsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports